// Recursively converts Rich Text nodes into HTML to be displayed within the table
export const renderHtmlNodes = (nodes: string | string[] | undefined) => {
  if (!Array.isArray(nodes)) {
    return "";
  }
  return nodes.join("");
};
